import { appSettingsInternalUserGroupsInternalUserGroupId } from "../appSettingsInternalUserGroupsInternalUserGroupId";
import type { AllRouteEndpoints } from "../routeTypes";
export const appSettingsInternalUserGroupsInternalUserGroupUpsertCacheKeys: AllRouteEndpoints[] = [
  "/internal_user_groups/internal_user_groups_data",
  appSettingsInternalUserGroupsInternalUserGroupId,
];
